import React from "react";
import { Box, Grid } from "@mui/material";
import { AppLayout } from "layout";
import { DiscoverDetailData } from "modules/Discover/components";

type Props = {};

const DiscoverDetailContainer = (props: Props) => {
  return (
    // <AppLayout>

    <DiscoverDetailData />

    // </AppLayout>
  );
};

export default DiscoverDetailContainer;
